import type { RootState } from 'models';

export const selectAppointment = ({ appointment }: RootState) => appointment.data;
export const selectDuration = ({ appointment }: RootState) => appointment.data?.duration;
